export const maxFileSize = 50 * 1024 * 1024; // = 20MB
